import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { reviews } from '../data/reviews';

/** Reseñas reales de compradores. Sin reseñas cargadas, no se muestra. */
export function Reviews() {
  if (reviews.length === 0) return null;
  return <section aria-labelledby="reviews-heading" className="arcs-light w-full bg-sand text-night" data-id="element-316" data-mp="2madv9zjxi4w9">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-317" data-mp="2r8p5wci1sjfj">
        <div className="text-center" data-id="element-318" data-mp="2w93f3xvdxzf5">
          <p className="eyebrow text-coral-deep" data-id="element-319" data-mp="2w8239r6jp8wd">From the mats</p>
          <h2 id="reviews-heading" className="lane-underline mt-3 font-display text-[30px] leading-tight text-night sm:text-5xl" data-id="element-320" data-mp="30a5eqft7sdhn">
            What teachers are seeing in class
          </h2>
        </div>

        <ul className={`mx-auto mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 ${reviews.length % 3 === 0 ? 'lg:grid-cols-3' : 'max-w-4xl'}`} data-id="element-321" data-mp="3a348ec3kiu84">
          {reviews.map(review => <li key={review.name} className="flex" data-id="element-322" data-mp="2rd6x22e2tun4">
              <figure className="flex w-full flex-col border-t-2 border-coral pt-5" data-id="element-323" data-mp="2rdyw5n6vuai5">
                <blockquote className="text-[17px] leading-relaxed text-night" data-id="element-324" data-mp="2mbzq25jrczhi">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-325" data-mp="2dcw854wbuq4l">
                  <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-night font-display text-sm text-sand" data-id="element-326" data-mp="2dez8ahr71zn1">
                    {initials(review.name)}
                  </span>
                  <span className="min-w-0 text-xs text-night-soft" data-id="element-327" data-mp="30bitwm5jdoo0">
                    <span className="block text-[14px] font-bold text-night" data-id="element-328" data-mp="2wap6dtw0abvn">
                      {review.name}
                    </span>
                    {review.role}
                    <span className="mt-0.5 flex items-center gap-1 text-night-muted" data-id="element-329" data-mp="3o2ejdcmis7s3">
                      <MapPinIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-330" data-mp="1m5nxqsj26ynb" />
                      {review.city}, {review.country}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2);
}